
import {createSlice} from '@reduxjs/toolkit'
import { fetchpaymentstatus } from '../../action/master/paymentstatusAction'

interface paymentstatusState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: paymentstatusState = {
  data: null,
  status: 'idle',
  error: null,
}

const paymentstatusSlice = createSlice({
  name: 'paymentstatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchpaymentstatus.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchpaymentstatus.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchpaymentstatus.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default paymentstatusSlice.reducer
